// ────────────────────────────────────────────────────────────────────────────
// Pending statement upload — module-level handoff (v1.14.3)
//
// File objects can't be passed through React Router or URL params, and
// stringifying them to localStorage loses the binary content. When the
// /statements upload dialog creates a new Statement and navigates to the
// Bill Importer, we stash the File in this module so the importer can pick
// it up on mount and trigger the appropriate parse flow (PDF queue or CSV
// preview). The handoff is consumed exactly once.
// ────────────────────────────────────────────────────────────────────────────

interface PendingUpload {
  statementId: string;
  file: File;
}

let pending: PendingUpload | null = null;

export function setPendingStatementUpload(statementId: string, file: File): void {
  pending = { statementId, file };
}

export function consumePendingStatementUpload(statementId: string): File | null {
  if (pending && pending.statementId === statementId) {
    const f = pending.file;
    pending = null;
    return f;
  }
  return null;
}

export function hasPendingStatementUpload(statementId: string): boolean {
  return !!(pending && pending.statementId === statementId);
}
